import React, { useEffect } from "react";
import "./MissionVision.css";

import missionImg from "../../assets/images/mission-vission-bg.jpg";
import visionImg from "../../assets/images/vision.jpg";

const MissionVision = () => {

  useEffect(() => {
    const cards = document.querySelectorAll(".mv-card, .mv-heading, .mv-scroll-line");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="mv-section">
      <div className="mv-container">

        <div className="mv-heading-wrap">
          <h2 className="mv-heading">Our Mission & Vision</h2>

          {/* Scrolling line under heading */}
          <div className="mv-scroll-line"></div>
        </div>

        <div className="mv-grid">

          {/* Mission */}
          <div className="mv-card">
            <div className="mv-media">
              <img src={missionImg} alt="Mission" />
            </div>
            <div className="mv-body">
              <span className="mv-label">Mission</span>
              <h3 className="mv-title">Empowering Businesses with Smart Growth</h3>
              <p className="mv-text">
              Our Aim is to ensure that every client who approach us is receiving the best services and are content with our work. 
              </p>
            </div>
          </div>

          {/* Vision */}
          <div className="mv-card">
            <div className="mv-media">
              <img src={visionImg} alt="Vision" />
            </div>
            <div className="mv-body">
              <span className="mv-label">Vision</span>
              <h3 className="mv-title">To Become a Trusted Partner for Future-Ready Brands</h3>
              <p className="mv-text">
              Our focus is on constantly striving to provide the best services and excel in our field and lead as examples for our students and future marketers.
              </p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default MissionVision;
